import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { OverflowTooltipDirective } from '@directives';
import { AppRoutingModule } from 'app/app-routing.module';
import { SharedPipesModule } from 'app/pipes/shared-pipes.module';

import { DrilldownChartNoDataAvailableModule } from '../drilldown-chart-no-data-available/drilldown-chart-no-data-available.module';
import { StatusBadgeModule } from '../status-badge/status-badge.module';
import { DrilldownTableComponent } from './drilldown-table.component';

@NgModule({
  declarations: [DrilldownTableComponent],
  exports: [DrilldownTableComponent],
  imports: [
    BrowserModule,
    DrilldownChartNoDataAvailableModule,
    MatTableModule,
    StatusBadgeModule,
    AppRoutingModule,
    OverflowTooltipDirective,
    MatTooltipModule,
    SharedPipesModule
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DrilldownTableModule {}
